<div style="font-family: &quot;Helvetica&quot;; overflow: hidden">
  <canvas #canvas id="canvas" style="background: gray; width: 20vw; height: 20vh"></canvas>
</div>
